if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.addEventListener(
          "submit",
          this.onSubmitHandler.bind(this)
        );

        this.cartNotification = document.querySelector("cart-notification");
        this.cartItems = document.querySelector("cart-items");
        this.quickViewWarpper = document.getElementById("quickViewWrapper");
        this.itemCount = document.getElementById(
          "cart-notification-count-item-cart"
        );
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        const submitButton = this.querySelector('[type="submit"]');

        submitButton.setAttribute("disabled", true);
        submitButton.classList.add("loading");

        let config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        let formData = new FormData(this.form);

        if (this.cartNotification) {
          formData.append(
            "sections",
            this.cartNotification
              .getSectionsToRender()
              .map((section) => section.id)
          );

          this.cartNotification.setActiveElement(document.activeElement);
        }

        if (this.cartItems) {
          formData.append(
            "sections",
            this.cartItems
              .getSectionsToRender()
              .map((section) => section.section)
          );
        }

        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((parsedState) => {
            if (parsedState.status) {
              this.handleErrorMessage(parsedState.description);
              return;
            }

            if (this.cartNotification) {
              this.cartNotification.renderContents(parsedState);
            }

            if (this.cartItems) {
              this.cartItems.renderContents(parsedState);
            }

            let cartItemCount = parseInt(
              this.getSectionInnerHTML(
                parsedState.sections["cart-notification-count"]
              )
            );

            // Compare numeric cents, not formatted price strings.
            const subtotalHTML = this.getSectionInnerHTML(
              parsedState.sections["cart-notification-subtotal"]
            );

            const subtotalText = new DOMParser()
              .parseFromString(subtotalHTML, "text/html")
              .body.textContent;

            const currentVal = Math.round(
              Number(subtotalText.replace(/[^0-9.-]/g, "")) * 100
            );

            const targetVal = Number(
              document
                .getElementById("price-free")
                ?.getAttribute("data-price-free")
            );

            document
              .querySelectorAll(".cart-notification-count-item-cart")
              .forEach((item) => {
                item.textContent = cartItemCount;
              });

            if (
              Number.isFinite(currentVal) &&
              Number.isFinite(targetVal) &&
              targetVal > 0
            ) {
              const eligible = currentVal >= targetVal;

              const remaining = (
                Math.max(0, targetVal - currentVal) / 100
              ).toFixed(2);

              const percent = Math.min(
                100,
                Math.max(0, (currentVal / targetVal) * 100)
              );

              document
                .querySelectorAll(".cart-shipping-wrapper")
                .forEach((wrapper) => {
                  const bar = wrapper.querySelector(
                    ".cart-shipping-progress"
                  );
                  const amount = wrapper.querySelector(
                    ".cart-shipping-num"
                  );
                  const prompt = wrapper.querySelector(
                    ".cart-shipping-num-inner"
                  );
                  const success = wrapper.querySelector(
                    ".cart-shipping-success"
                  );

                  if (bar) {
                    bar.style.width = percent + "%";
                  }

                  if (amount) {
                    amount.textContent = remaining;
                  }

                  if (prompt) {
                    prompt.style.display = eligible ? "none" : "flex";
                  }

                  if (success) {
                    success.style.display = eligible ? "flex" : "none";
                  }
                });
            }

            document
              .querySelector(".product-form-error-message-wrapper")
              ?.classList.add("no-js-inline");
          })
          .finally(() => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("disabled");
            this.quickViewWarpper?.classList.remove("show__modal");
            document.body.classList.remove("overflow-hidden");
          });
      }

      getSectionInnerHTML(html, selector = ".shopify-section") {
        return new DOMParser()
          .parseFromString(html, "text/html")
          .querySelector(selector).innerHTML;
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form-error-message-wrapper");

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(".product-form-error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
          this.errorMessageWrapper.classList.remove("no-js-inline");
        }
      }
    }
  );
}